export const baseURL ="https://"+process.env.REACT_APP_DOMAIN_NAME+"/v1/"
export const exceptThisSymbols = ['e', 'E', '+', '-', '.',''];
export const branchLiveKey =process.env.REACT_APP_BRANCH_LIVE_KEY
export const CDN = process.env.REACT_APP_CDN+"public/";
export const STAGE = process.env.REACT_APP_STAGE


